import { useEffect, useState } from "react";
import { Col, Row, Form, Typography, Flex, Divider } from "antd";

import { capitalize } from "lodash";

import dayjs from "dayjs";

import { GET } from "../../../../providers/useAxiosQuery";

import FloatSelect from "../../../../providers/FloatSelect";
import optionStudentStatus from "../../../../providers/optionStudentStatus";
import validateRules from "../../../../providers/validateRules";
import optionTrack from "../../../../providers/optionTrack";
import PreferredExamCalendar from "../components/PreferredExamCalendar";

export default function ApplicantFormExamInfo(props) {
	const {
		form,
		handleStudentLevelChange,
		examSchedule,
		setExamSchedule,
		setPaymentDue,
	} = props;

	// const form = Form.useFormInstance();

	const [selectExamSchedule, setSelectExamSchedule] = useState();
	const [optionStrand, setOptionStrand] = useState([]);

	const [tableFilter] = useState({
		page: 1,
		page_size: 50,
		search: "",
		sort_field: "created_at",
		sort_order: "desc",
		isTrash: 0,
	});

	const { data: dataSchoolLevel } = GET(`api/school_level`, "school_level");

	const { data: dataExamCategory } = GET(
		`api/exam_category`,
		"exam_category_list"
	);

	console.log("dataExamCategory: ", dataExamCategory);

	const {
		data: dataStudentExam,
		refetch: refetchStudentExam,
	} = GET(`api/student_exams`, "student_exams_list", (res) => {});

	const { data: dataCourse } = GET(`api/course`, "course_list");
	const { data: dataDepartment } = GET(`api/department`, "department_list");

	const departmentList =
		dataDepartment && dataDepartment.data
			? dataDepartment.data.map((department) => ({
					id: department.id,
					department_name: department.department_name,
			  }))
			: [];

	// Degree Programs Offered
	const getFilteredOptions = (departmentName) => {
		return dataCourse && dataCourse.data
			? dataCourse.data
					.filter((item) =>
						departmentList.some(
							(department) =>
								department.id === item.department_id &&
								(departmentName === "College"
									? department.department_name !== "Graduate Studies Program" &&
									  department.department_name !== "College of Law"
									: department.department_name === departmentName)
						)
					)
					.map((item) => ({
						label: item.course_name,
						value: item.id,
					}))
					.sort((a, b) => a.label.localeCompare(b.label))
			: [];
	};

	// Possible disable selected course, para di mag duplicate
	// Clear selected course each time exam category changes
	const clearSelectedCourse = (exam_category) => {
		const courseFields = [
			"first_course_id",
			"second_course_id",
			"third_course_id",
		];

		courseFields.forEach((course) => {
			form.setFieldsValue({ [course]: undefined });
		});
	};

	const renderCourseSelection = (exam_category) => {
		const courseOptions = {
			1: getFilteredOptions("College"),
			2: getFilteredOptions("Graduate Studies Program"),
			// 3: getFilteredOptions("College of Law"),
		};

		const categoryTitles = {
			1: "*For College Category Only",
			2: "*For Graduate Studies Category Only",
			// 3: "*For College of Law Category Only",
		};

		return (
			<>
				{exam_category in categoryTitles && (
					<>
						<Typography.Title level={5} type="danger" className="mt-0">
							{categoryTitles[exam_category]}
						</Typography.Title>

						<Col xs={24} sm={24} md={24} lg={24} xl={24} className="p-0 ml-10">
							<p className="mt-0 mb-0">
								<strong>Degree Programs Offered:</strong> Kindly select your
								preferred degree.
							</p>
						</Col>

						{["first_course_id", "second_course_id", "third_course_id"].map(
							(course, index) => (
								<Col xs={24} sm={24} md={24} lg={24} xl={24} key={index}>
									<Form.Item
										name={course}
										rules={[validateRules.quillValidator]}
									>
										<FloatSelect
											label={`${capitalize(course.split("_")[0])} Course`}
											placeholder={`${capitalize(course.split("_")[0])} Course`}
											required={true}
											allowClear={true}
											options={[
												...(course !== "first_course_id"
													? [
															{ label: "Undecided", value: -1 },
															{ label: "No Chosen Course", value: -2 },
													  ]
													: []),
												...courseOptions[exam_category],
											]}
										/>
									</Form.Item>
								</Col>
							)
						)}
					</>
				)}
			</>
		);
	};

	useEffect(() => {
		const setExamDate = dataStudentExam?.dataExamSchedules?.find(
			(item) => item.id === examSchedule
		);

		setSelectExamSchedule(setExamDate);
		setPaymentDue(setExamDate);
		form.setFieldsValue({ exam_schedule_id: examSchedule });
	}, [examSchedule, dataStudentExam, form]);

	return (
		<>
			<Row gutter={[18, 0]}>
				<Col xs={24} sm={24} md={24} lg={24} xl={24}>
					<Flex className="preferred-exam-schedule">
						{/* left column */}
						<Col xs={24} sm={24} md={12} lg={12} xl={12}>
							<Col xs={24} sm={24} md={24} lg={24} xl={24}>
								<Typography.Title level={4} className="mt-0">
									Exam Schedule
								</Typography.Title>
							</Col>

							{/* Exam Schedule Calendar */}
							<Col
								xs={24}
								sm={24}
								md={24}
								lg={24}
								xl={24}
								id="PreferredExamCalendar"
							>
								<Form.Item
									name="exam_schedule_id"
									// rules={[validateRules.quillValidator]}
								>
									<PreferredExamCalendar
										dataStudentExam={dataStudentExam}
										setExamSchedule={setExamSchedule}
									/>
								</Form.Item>
							</Col>
						</Col>

						{/* right column */}
						<Col xs={24} sm={24} md={12} lg={12} xl={12}>
							<Typography.Title level={4} className="mt-0">
								INSTRUCTION
							</Typography.Title>

							<p className="mb-0">
								To select exam schedule, please choose an available date from
								the calendar.
							</p>

							<ul>
								<li>You can choose only one preferred exam schedule.</li>

								<li>
									Only dates with available schedules and slots can be selected.
								</li>
								<li>
									<span style={{ color: "grey" }}>
										<strong>Grey:</strong>{" "}
									</span>{" "}
									Indicates that the exam schedule is locked.
								</li>
								<li>
									<span style={{ color: "green" }}>
										<strong>Green:</strong>{" "}
									</span>{" "}
									Indicates there are available slots.
								</li>
								<li>
									<span style={{ color: "red" }}>
										<strong>Red:</strong>{" "}
									</span>{" "}
									Indicates no more available slots for that date.
								</li>
								<li>
									Click <strong>"+more"</strong> to view all schedules for a
									specific date.
								</li>
							</ul>

							<Divider />

							<Col xs={24} sm={24} md={24} lg={24} xl={24}>
								<Typography.Title level={4} className="mt-0">
									Preferred Exam Schedule
								</Typography.Title>
							</Col>

							<Form.Item shouldUpdate noStyle>
								{() => {
									let exam_schedule = form.getFieldValue("exam_schedule_id");

									if (exam_schedule !== undefined || exam_schedule !== null) {
										return (
											<>
												<Col>
													{selectExamSchedule ? (
														""
													) : (
														<>
															<em
																style={{
																	fontSize: "14px",
																	fontSize: "400",
																	color: "red",
																}}
															>
																Please select schedule from the calendar.
															</em>
															<br />
														</>
													)}
													<Typography.Title level={5} className="mt-0">
														{/* Exam Date */}
														<span style={{ fontWeight: "normal" }}>
															Date:
														</span>{" "}
														<span
															className="pr-20"
															style={{ color: "#447ce2" }}
														>
															{selectExamSchedule
																? dayjs(selectExamSchedule.exam_date).format(
																		"MMMM DD, YYYY"
																  )
																: "???"}
														</span>
														{/* Exam Time */}
														<span style={{ fontWeight: "normal" }}>
															Time:
														</span>{" "}
														<span
															className="pr-20"
															style={{ color: "#447ce2" }}
														>
															{selectExamSchedule ? (
																<>
																	{selectExamSchedule.time_in}{" "}
																	{selectExamSchedule.time_in_meridiem} -{" "}
																	{selectExamSchedule.time_out}{" "}
																	{selectExamSchedule.time_out_meridiem}
																</>
															) : (
																"???"
															)}
														</span>
														{/* Exam Slots */}
														<span style={{ fontWeight: "normal" }}>
															Available Slot/s:
														</span>{" "}
														<span
															className="pr-20"
															style={{ color: "#447ce2" }}
														>
															{selectExamSchedule
																? selectExamSchedule.total_available_slot
																: "???"}
														</span>
													</Typography.Title>
												</Col>
											</>
										);
									} else {
										return null;
									}
								}}
							</Form.Item>

							<Divider />

							<Col xs={24} sm={24} md={24} lg={24} xl={24}>
								{/* Exam Fee */}
								<Form.Item shouldUpdate noStyle>
									{() => {
										let exam_category_id = form.getFieldValue(
											"exam_category_id"
										);

										let exam_fee =
											dataExamCategory &&
											dataExamCategory.data &&
											dataExamCategory.data.find(
												(item) => item.id === exam_category_id
											)?.exam_fee;

										return (
											// Find the corresponding exam fee
											<>
												<p className="mt-0 mb-20">
													<strong>
														Testing Fee:
														<span style={{ color: "#ff4d4f" }}>
															{" "}
															{exam_fee ? "₱ " + exam_fee + ".00" : "???"}
														</span>
													</strong>
													<em>
														{" "}
														Please note that the entrance exam fee must be paid
														within three days prior to the exam date to secure
														your spot. Failure to pay the fee may result in the
														cancellation of your exam reservation.
													</em>
												</p>
											</>
										);
									}}
								</Form.Item>

								<Flex>
									{/* Exam Category */}
									<Col xs={24} sm={24} md={12} lg={12} xl={12}>
										<Form.Item
											name="exam_category_id"
											rules={[validateRules.required]}
										>
											<FloatSelect
												label="Exam Category"
												placeholder="Exam Category"
												required={true}
												options={
													dataExamCategory && dataExamCategory.data
														? dataExamCategory.data
																.map((item) => ({
																	label: item.category,
																	value: item.id,
																}))
																.sort((a, b) => a.value - b.value)
														: []
												}
												onChange={() => {
													form.setFieldsValue({
														student_status: null,
														student_level_id: null,
														student_track: null,
														student_strand: null,
														current_course_id: null,
														first_course_id: null,
														second_course_id: null,
														third_course_id: null,
													});
												}}
											/>
										</Form.Item>
									</Col>

									{/* Student Status */}
									<Col xs={24} sm={24} md={12} lg={12} xl={12}>
										<Form.Item shouldUpdate noStyle>
											{() => {
												return (
													<>
														<Form.Item
															name="student_status"
															rules={[validateRules.quillValidator]}
														>
															<FloatSelect
																label="Student Status"
																placeholder="Student Status"
																required={true}
																options={[
																	// {
																	// 	label: "Pursuing a Second Degree",
																	// 	value: "Pursuing a Second Degree",
																	// },
																	...optionStudentStatus,
																]}
															/>
														</Form.Item>
													</>
												);
											}}
										</Form.Item>
									</Col>
								</Flex>

								{/* Current Academic Status */}
								<Form.Item shouldUpdate noStyle>
									{() => {
										let exam_category_id = form.getFieldValue(
											"exam_category_id"
										);

										if (exam_category_id == 1) {
											return (
												<>
													<Col xs={24} sm={24} md={24} lg={24} xl={24}>
														<Typography.Title level={5} className="mt-0">
															Current Academic Status
														</Typography.Title>
													</Col>

													<Flex>
														{/* Student Level */}
														<Col xs={24} sm={24} md={24} lg={12} xl={12}>
															<Form.Item
																name="student_level_id"
																rules={[validateRules.quillValidator]}
															>
																<FloatSelect
																	label="Student Level"
																	placeholder="Student Level"
																	required={true}
																	options={
																		dataSchoolLevel?.data
																			?.filter(
																				(item) => item.id === 5 || item.id === 4
																			)
																			.map((item) => ({
																				label: item.school_level,
																				value: item.id,
																			})) || []
																	}
																	onChange={handleStudentLevelChange}
																/>
															</Form.Item>

															<Form.Item shouldUpdate noStyle>
																{() => {
																	const student_level_id = form.getFieldValue(
																		"student_level_id"
																	);

																	if (student_level_id === 5) {
																		return (
																			<Form.Item
																				name="student_track"
																				rules={[validateRules.quillValidator]}
																			>
																				<FloatSelect
																					label="Track"
																					placeholder="Track"
																					required={true}
																					allowClear={true}
																					options={optionTrack}
																					onChange={(track) => {
																						const filteredOptions = optionTrack
																							.filter(
																								(item) => item.value === track
																							)
																							.flatMap((item) => item.options)
																							.map((option) => ({
																								value: option.abbr,
																								label: option.strand,
																							}));

																						form.setFieldsValue({
																							student_strand: null,
																						});
																						setOptionStrand(filteredOptions);
																					}}
																				/>
																			</Form.Item>
																		);
																	}
																}}
															</Form.Item>
														</Col>

														<Col xs={24} sm={24} md={24} lg={12} xl={12}>
															<Flex vertical>
																<Form.Item shouldUpdate noStyle>
																	{() => {
																		const student_level_id = form.getFieldValue(
																			"student_level_id"
																		);

																		if (student_level_id === 5) {
																			return (
																				<Form.Item
																					name="current_course_id"
																					rules={[validateRules.quillValidator]}
																				>
																					<FloatSelect
																						label="Current Course"
																						placeholder="Current Course"
																						required={true}
																						allowClear={true}
																						options={
																							dataCourse?.data
																								?.filter(
																									(item) =>
																										!item.course_name.includes(
																											"Doctor"
																										) &&
																										!item.course_name.includes(
																											"Master"
																										)
																								)
																								.map((item) => ({
																									label: item.course_name,
																									value: item.id,
																								}))
																								.sort((a, b) =>
																									a.label.localeCompare(b.label)
																								) || []
																						}
																					/>
																				</Form.Item>
																			);
																		} else if (student_level_id === 4) {
																			return (
																				<>
																					<Form.Item
																						name="student_track"
																						rules={[
																							validateRules.quillValidator,
																						]}
																					>
																						<FloatSelect
																							label="Track"
																							placeholder="Track"
																							required={true}
																							allowClear={true}
																							options={optionTrack}
																							onChange={(track) => {
																								const filteredOptions = optionTrack
																									.filter(
																										(item) =>
																											item.value === track
																									)
																									.flatMap(
																										(item) => item.options
																									)
																									.map((option) => ({
																										value: option.abbr,
																										label: option.strand,
																									}));

																								form.setFieldsValue({
																									student_strand: null,
																								});
																								setOptionStrand(
																									filteredOptions
																								);
																							}}
																						/>
																					</Form.Item>

																					<Form.Item
																						name="student_strand"
																						rules={[
																							validateRules.quillValidator,
																						]}
																					>
																						<FloatSelect
																							label="Strand"
																							placeholder="Strand"
																							required={true}
																							allowClear={true}
																							options={optionStrand}
																						/>
																					</Form.Item>
																				</>
																			);
																		} else {
																			return null;
																		}
																	}}
																</Form.Item>
															</Flex>

															<Form.Item shouldUpdate noStyle>
																{() => {
																	const student_level_id = form.getFieldValue(
																		"student_level_id"
																	);

																	if (student_level_id === 5) {
																		return (
																			<Form.Item
																				name="student_strand"
																				rules={[validateRules.quillValidator]}
																			>
																				<FloatSelect
																					label="Strand College"
																					placeholder="Strand College"
																					required={true}
																					allowClear={true}
																					options={optionStrand}
																				/>
																			</Form.Item>
																		);
																	} else {
																		return null;
																	}
																}}
															</Form.Item>
														</Col>
													</Flex>
												</>
											);
										} else {
											return null;
										}
									}}
								</Form.Item>

								{/* Degree Programs Offered */}
								<Form.Item shouldUpdate noStyle>
									{() => {
										let exam_category = form.getFieldValue("exam_category_id");

										if (exam_category === 1) {
											// College
											return renderCourseSelection(exam_category);
										} else if (exam_category === 2) {
											// Graduate Studies
											return renderCourseSelection(exam_category);
										} else if (exam_category === 3) {
											// College of Law
											return renderCourseSelection(exam_category);
										}
									}}
								</Form.Item>
							</Col>
						</Col>
					</Flex>
				</Col>
			</Row>
		</>
	);
}
